import type { Decimal } from '@snap-types/types/decimal';

export function commaSeparated(
  input: number | string,
  options?: Intl.NumberFormatOptions,
): string {
  const formatter = new Intl.NumberFormat('en-US', {
    useGrouping: true,
    ...options,
  });

  // According to spec, Intl.NumberFormat.format accepts strings, but the type in
  // TS is restricted to numbers. This has been fixed in main and is slated for released in 5.5.
  //
  // https://github.com/microsoft/TypeScript/pull/57595
  //
  // Once our TS is upgraded to 5.5+, we can remove this type assertion.
  //
  // incorrect type in TS for Intl.NumberFormat.format
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return formatter.format(input as any);
}

export function currency(
  value: Decimal,
  config?: {
    decimalPlaces?: number;
    separator?: boolean;
  },
) {
  const rounded = value.toFixed(config?.decimalPlaces ?? 2);

  const formatted = commaSeparated(rounded, {
    minimumFractionDigits: 2,
    maximumFractionDigits: config?.decimalPlaces ?? 2,
    useGrouping: config?.separator ?? false,
  });

  return `$${formatted}`;
}
